/**
 * Composable do wyliczania wysokości iframe
 * Wymaga:
 *      - `ref="iframe"` na iframe
 *      - `:style="{height: iframeHeight}"` na iframe
 * @param {*} containerClass
 */
export function iframeMixin(containerClass = 'modal-body') {
  return {
    data() {
      return { iframeHeight: '0px' };
    },

    computed: {
      // Nadpisać w komponencie jeżeli ma być liczone jakoś inaczej
      isIframeVisible() {
        return this.step === 2;
      }
    },

    methods: {
      calcIframeHeight(iframeRef) {
        const modalBody = this.getContainer(iframeRef);
        return `calc(${modalBody.clientHeight}px - 4rem)`;
      },

      getContainer(iframeRef) {
        let parent = iframeRef.parentElement;
        while (!parent.classList.contains(containerClass)) {
          parent = parent.parentElement;
        }
        return parent;
      }
    },

    watch: {
      isIframeVisible(newValue) {
        if (!newValue) {
          return;
        }

        this.$nextTick(() => {
          this.iframeHeight = this.calcIframeHeight(this.$refs.iframe);
        });
      }
    }
  };
}
